import {Component} from "react";
import * as React from "react";

import {Helmet} from "react-helmet";

interface PageTitleProps
{
    title?: string;
}

interface PageTitleState
{
    title: string;
}

export default class PageTitle extends Component<PageTitleProps,PageTitleState>
{
    constructor(props: Readonly<PageTitleProps>) {
        super(props);
        
        this.state = {
            title: ""
        };
    }

    private setTitleState()
    {
        let title = this.props.title || "";
        let titlePrefix = process.env.REACT_APP_TITLE_PREFIX;

        if(titlePrefix)
        {
            title = `${titlePrefix} ${title}`;
        }

        this.setState({
            title
        });
    }
    
    public componentDidMount() {
        this.setTitleState();
    }

    componentDidUpdate(prevProps: Readonly<PageTitleProps>, prevState: Readonly<PageTitleState>, snapshot?: any) {
        if(this.props.title !== prevProps.title)
        {
            this.setTitleState();
        }
    }

    public render() {
        return (
            <Helmet>
                <title>{this.state.title}</title>
            </Helmet>
        );
    }
}
